import * as React from "react";
const SaveIcon = (props) => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5625 0.00622559H2.43749C1.48124 0.00622559 0.721863 0.765601 0.721863 1.72185V10.75C0.721863 11.1719 0.890613 11.5656 1.19999 11.8469L6.26249 16.6281C6.54374 16.9094 6.90936 17.05 7.30311 17.05H12.5625C13.5187 17.05 14.2781 16.2906 14.2781 15.3344V1.72185C14.2781 0.765601 13.5187 0.00622559 12.5625 0.00622559ZM2.91561 11.7062H6.20624C6.34686 11.7062 6.45936 11.8187 6.45936 11.9312V15.025L2.91561 11.7062ZM13.0125 15.2781C13.0125 15.5312 12.8156 15.7281 12.5625 15.7281H7.72499V11.9312C7.72499 11.1156 7.04999 10.4406 6.20624 10.4406H1.98749V1.72185C1.98749 1.46873 2.18436 1.27185 2.43749 1.27185H12.5625C12.8156 1.27185 13.0125 1.46873 13.0125 1.72185V15.2781Z"
      fill="currentcolor"
    />
  </svg>
);
export default SaveIcon;
